export const agregarMensajeTemporizador = (setMessage) => {
    const idTime = setTimeout(() => {
        setMessage({ type: null });
        clearTimeout(idTime);
    }, 3000);
}
